import { CHAT_NAME_MAX_LENGTH } from '@common/Copilot/CopilotAgentChat/agent-v4/InlineRename';
import { getInterFontWeightCSS, theme } from '@prophecy/theme';
import { Input } from '@prophecy/ui-v3/Input';
import { StyledInput, StyledInputContainer } from '@prophecy/ui-v3/Input/styled';
import styled from 'styled-components';

import type React from 'react';

// The mock renames in place: the title itself turns editable and selected, with no box around it.
const TitleInput = styled(Input)<{ $weight: string; $tone: string }>`
  width: 100%;

  ${StyledInputContainer} {
    height: auto;
    padding: 0;
    border: none;
    outline: none;
    box-shadow: none;
    background: transparent;
  }

  ${StyledInput} {
    padding: 0;
    font-size: ${theme.text.sm.fontSize};
    line-height: ${theme.text.sm.lineHeight};
    color: ${({ $tone }) => $tone};
    ${({ $weight }) => getInterFontWeightCSS($weight)};
  }
`;

export function ChatTitleInput({
  value,
  weight,
  tone,
  onChange,
  onSubmit,
  onKeyDown,
  'data-test-id': dataTestId
}: {
  value: string;
  weight: string;
  tone: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  onKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  'data-test-id': string;
}) {
  return (
    <TitleInput
      // eslint-disable-next-line jsx-a11y/no-autofocus
      autoFocus
      $weight={weight}
      $tone={tone}
      inputSize='s'
      value={value}
      maxLength={CHAT_NAME_MAX_LENGTH}
      aria-label='Rename conversation'
      onChange={onChange}
      onFocus={(event) => event.currentTarget.select()}
      onPressEnter={(event) => event.currentTarget.blur()}
      onBlur={onSubmit}
      onKeyDown={onKeyDown}
      data-test-id={dataTestId}
    />
  );
}
